module.exports = "/* You can add global styles to this file, and also import other style files */\r\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/@angular/cli/node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/@angular/cli/node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles